export const clearNbsp = (text) => {
  if (typeof text === 'string') {
    return text.replace(/&nbsp;/g, '\u00A0');
  } else {
    return 'Error: is not a string.';
  }
};
